<template>
  <svg width="23"
       height="23"
       viewBox="0 0 23 23"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1637_2980)">
      <rect x="23"
            width="23"
            height="23"
            rx="11.5"
            transform="rotate(90 23 0)"
            fill="#2B3C44" />
      <g clip-path="url(#clip1_1637_2980)">
        <path
          d="M9.7381 6.73169C7.15384 6.87804 6.49733 10.0773 8.30739 11.197L7.82678 12.0328L6 10.9738V6.58874L9.17121 4.75035C9.04857 5.63077 9.34799 6.2631 9.7381 6.73169ZM14.6901 11.197L15.1707 12.0328L16.9974 10.9738V6.58874L13.9342 4.81294C14.0181 5.56034 13.8181 6.19891 13.3532 6.73608C15.611 6.87804 16.6637 9.85895 14.6901 11.197ZM13.6778 5.13782C13.6778 3.49784 11.8976 2.46731 10.481 3.2873C9.06447 4.10729 9.0645 6.16837 10.481 6.98836C11.8975 7.80835 13.6778 6.7778 13.6778 5.13782Z"
          fill="white" />
        <path
          d="M9.7381 6.73169C7.15384 6.87804 6.49733 10.0773 8.30739 11.197L7.82678 12.0328L6 10.9738V6.58874L9.17121 4.75035C9.04857 5.63077 9.34799 6.2631 9.7381 6.73169ZM14.6901 11.197L15.1707 12.0328L16.9974 10.9738V6.58874L13.9342 4.81294C14.0181 5.56034 13.8181 6.19891 13.3532 6.73608C15.611 6.87804 16.6637 9.85895 14.6901 11.197ZM13.6778 5.13782C13.6778 3.49784 11.8976 2.46731 10.481 3.2873C9.06447 4.10729 9.0645 6.16837 10.481 6.98836C11.8975 7.80835 13.6778 6.7778 13.6778 5.13782Z"
          fill="white"
          fill-opacity="0.2" />
      </g>
    </g>
    <rect x="22.5"
          y="0.5"
          width="22"
          height="22"
          rx="11"
          transform="rotate(90 22.5 0.5)"
          stroke="#2B3C44" />
    <defs>
      <clipPath id="clip0_1637_2980">
        <rect x="23"
              width="23"
              height="23"
              rx="11.5"
              transform="rotate(90 23 0)"
              fill="white" />
      </clipPath>
      <clipPath id="clip1_1637_2980">
        <rect width="11" height="13" fill="white" transform="translate(6 3)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {}
}
</script>
